import {
  AUTH_LOGIN,
  AUTH_REGISTER,
  HANDLE_LOADING,
  HANDLE_ERROR,
  AUTH_LOGOUT,
} from "./actionTypes";
import { AUTH_LOGIN_URL, AUTH_REGISTER_URL } from "../../config";

import axios from "axios";

export const authLogin = (data) => (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  return axios({
    url: AUTH_LOGIN_URL,
    method: "POST",
    data,
  })
    .then((response) => {
      const user = response.data.data;
      if (typeof user === "object") {
        dispatch({ type: HANDLE_LOADING, payload: false });
        return dispatch({ type: AUTH_LOGIN, payload: user });
      } else {
        dispatch({ type: HANDLE_LOADING, payload: false });
        dispatch({ type: AUTH_LOGIN, payload: null });
        dispatch({ type: HANDLE_ERROR, payload: response.data });
      }
    })
    .catch(function (error) {
      localStorage.clear();
      dispatch({ type: HANDLE_LOADING, payload: false });
      dispatch({ type: AUTH_LOGIN, payload: null });
      dispatch({ type: HANDLE_ERROR, payload: error });
      dispatch({ type: AUTH_LOGOUT });
    });
};

export const authLogout = () => (dispatch) => {
  dispatch({ type: AUTH_LOGOUT });
};

export const authRegister = (data) => (dispatch) => {
  dispatch({ type: HANDLE_LOADING, payload: true });
  dispatch({ type: HANDLE_ERROR, payload: null });
  return axios
    .post(AUTH_REGISTER_URL, data)
    .then((response) => {
      let res = response.data.data;
      if (res) {
        dispatch({ type: HANDLE_LOADING, payload: true });
        return dispatch({ type: AUTH_REGISTER, payload: true });
      } else {
        dispatch({ type: HANDLE_LOADING, payload: false });
        return dispatch({ type: AUTH_REGISTER, payload: true });
      }
    })
    .catch(function (error) {
      dispatch({ type: HANDLE_LOADING, payload: false });
      dispatch({ type: AUTH_REGISTER, payload: false });
      dispatch({ type: HANDLE_ERROR, payload: error });
    });
};
